import { useLocation } from 'react-router-dom';

const useHydrateFilterValues = (filters) => {
  const { search } = useLocation();

  const params = new URLSearchParams(search);

  const requestFilters = Object.keys(filters).reduce((acc, cur) => {
    return { ...acc, [cur]: params[cur] || filters[cur] };
  }, {});

  return requestFilters;
};

export { useHydrateFilterValues };
